import { render, staticRenderFns } from "./InquiryAsBlanketVOB.vue?vue&type=template&id=3ed813f3&scoped=true"
import script from "./InquiryAsBlanketVOB.vue?vue&type=script&lang=js"
export * from "./InquiryAsBlanketVOB.vue?vue&type=script&lang=js"
import style0 from "./InquiryAsBlanketVOB.vue?vue&type=style&index=0&id=3ed813f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed813f3",
  null
  
)

export default component.exports